import { Field } from 'api/tasks';
import { TextFieldFilter, TextFieldFilterOperationType } from '../filters/text';
import { getFieldValue } from './get-field-value';
import type { FilterFunction } from './types';

export const text = (filter: TextFieldFilter): FilterFunction => {
  const value = getFieldValue<string>(filter.field as any as Field);

  switch (filter.type) {
    case TextFieldFilterOperationType.IsEmpty:
      return (record) => value(record) == null || value(record) === '';
    case TextFieldFilterOperationType.IsNotEmpty:
      return (record) => value(record) != null && value(record) !== '';
    case TextFieldFilterOperationType.Contains:
      return (record) =>
        ((value(record) as string | undefined) ?? '')
          .toLowerCase()
          .includes(filter.value!.toLowerCase()) ?? false;
    case TextFieldFilterOperationType.DoesNotContain:
      return (record) =>
        !((value(record) as string | undefined) ?? '')
          .toLowerCase()
          .includes(filter.value!.toLowerCase()) ?? true;
    default:
      return () => true;
  }
};
